$(window).scroll(function(){
  var sticky = $('.logo a img'),
      scroll = $(window).scrollTop();

  if (scroll > 15) {
  	sticky.addClass('adjustLogo');
    $('.logo').addClass('logoAdjust');
  }
     
  else{
  	sticky.removeClass('adjustLogo');
    $('.logo').removeClass('logoAdjust');
  } 
});

$(window).scroll(function(){
  var stp = $('.scroll-to-top'),
      scroll = $(window).scrollTop();

  if (scroll > 15) {
    stp.css({display:'block'});
  }
     
  else{
  	stp.css({display:'none'});
  } 
});